import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06e5333f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-pt-0 tw-flex tw-flex-col" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(`tw-px-[40px] tw-pb-[40px] tw-flex sm:tw-flex-row tw-flex-col tw-justify-between tw-gap-[15px] sm:tw-gap-[0px]`)
}
const _hoisted_3 = { class: "tw-flex tw-gap-[10px] tw-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "tw-h-[39px] tw-w-[39px] tw-text-[#FFF]"
}
const _hoisted_5 = { key: 1 }

import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import { computed, onMounted, onUnmounted, ref } from "vue";
import ModalComponent from "@/components/common/modalComponent.vue";
import store from "@/store";
import RecipientsDetails from "./recipientDetails.vue";
import type RecipientsDetailsType from "./recipientDetails.vue";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";
import { Vendor } from "@/services/apiRoutes/routes";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";

const maxWidth = 65;

export default /*#__PURE__*/_defineComponent({
  __name: 'changeRecipientVendorAssessmentModal',
  props: {
  checklistRequestedId: {
    type: Number,
    required: true,
    default: null,
  },
  emailGrantId: {
    type: Number,
    required: true,
    default: null,
  },
  providerId: {
    type: Number,
    required: true,
    default: null,
  },
  offererOrgName: {
    type: String,
    required: false,
    default: "",
  },
  recipientEmail: {
    type: String,
    required: false,
    default: "",
  },
  validFrom: {
    type: String,
    required: false,
    default: "",
  },
  validUntil: {
    type: String,
    required: false,
    default: "",
  },
},
  emits: ["update:show", "update:data", "update:close"],
  setup(__props, { emit }) {

const props = __props;



let showRef = ref(true);
const recipientsDetailsRef = ref<InstanceType<
  typeof RecipientsDetailsType
> | null>(null);
const isLoadingAPI = ref(false);
const isRequiredRecipientDetails = ref(false);
const recipientsDetailsModal = ref({
  name: props.offererOrgName,
  email: props.recipientEmail,
  expiryDate: props.validUntil,
});

const screenWidth = ref(window.innerWidth);

const updateWidth = () => {
  screenWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", updateWidth);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWidth);
});



const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const putChecklistRequested = async () => {
  isLoadingAPI.value = true;
  const params = {
    checklistRequestedId: props.checklistRequestedId,
    emailGrantId: props.emailGrantId,
    providerId: props.providerId,
  };
  const body = {
    recipientEmail: recipientsDetailsModal.value.email,
    offererOrgName: recipientsDetailsModal.value.name,
    validUntil: recipientsDetailsModal.value.expiryDate,
  };
  try {
    const validate = await recipientsDetailsRef.value?.isCheckValid();
    if (!validate) {
      isLoadingAPI.value = false;
      return;
    }
    if (!props.offererOrgName && !props.recipientEmail && !props.validUntil) {
      const recipientName = recipientsDetailsModal.value.name.split(" ");
      const recipientFirstName = recipientName[0];
      const recipientLastName = recipientName.slice(1).join(" ");
      await store.dispatch("Vendor/postChecklistRequestedGetSecret", {
        payload: {
          checklistRequestedId: props.checklistRequestedId,
          recipientEmail: recipientsDetailsModal.value.email,
          recipientFirstName,
          recipientLastName,
          offererOrgName: recipientsDetailsModal.value.name,
          validUntil: recipientsDetailsModal.value.expiryDate,
        },
        providerId: props.providerId,
        checklistRequestedId: props.checklistRequestedId,
      });
    } else {
      await store.dispatch("Vendor/updateChecklistRequestedEmailGrant", {
        params,
        body,
      });
    }
    showSuccessToast(
      getComponentUiText(
        "app-vendor-assessment-change-recipient-assessment-success-1",
      ),
    );
    handleCloseModal();
  } catch (error) {
    isLoadingAPI.value = false;
    showErrorAPI(error, Vendor.putChecklistRequestedEmailGrant);
  }
};

const styleClassContain = computed(() => ({
  "border-radius": "6px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
  overflow: screenWidth.value >= 600 ? "unset !important" : "auto",
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalComponent, {
    "model-value": _unref(showRef),
    close: () => handleCloseModal(),
    "max-width": maxWidth,
    "style-class-contain": styleClassContain.value,
    "modal-class": _unref(showRef) ? 'date-picker-modal' : ''
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        style: {"z-index":"10"},
        title: 
        _unref(getComponentUiText)(
          'app-vendor-assessment-change-recipient-assessment-modal-title-1',
        )
      ,
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(RecipientsDetails, {
          ref_key: "recipientsDetailsRef",
          ref: recipientsDetailsRef,
          modelValue: recipientsDetailsModal.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((recipientsDetailsModal).value = $event)),
          "onUpdate:isDisabled": _cache[1] || (_cache[1] = (val) => (isRequiredRecipientDetails.value = val))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "tw-bg-[#fff] hover:!tw-bg-[#F7553C] hover:tw-text-[#fff] tw-text-[#F7553C] tw-border-[2px] tw-border-solid tw-border-[#F7553C] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-rounded-[27px] tw-w-fit tw-h-[39px] tw-leading-[100%] tw-font-medium tw-flex tw-items-center tw-justify-center",
          onClick: handleCloseModal
        }, _toDisplayString(_unref(getComponentUiText)(
            "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
          )), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["tw-flex tw-items-center tw-bg-[#DBDBDB] tw-text-[#B7B7B7] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-rounded-[27px] tw-h-[39px] tw-leading-[100%] tw-font-medium", `${'!tw-bg-[#387DFF] tw-text-white hover:!tw-bg-[#0069d9]'}`]),
            onClick: putChecklistRequested
          }, [
            (isLoadingAPI.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_unref(LottieAnimation), {
                    ref: "anim",
                    "animation-data": _unref(ProgressAnimation),
                    "auto-play": true,
                    loop: true
                  }, null, 8, ["animation-data"])
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)(
                "app-vendor-assessment-change-recipient-assessment-btn-resend-1",
              )), 1))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "close", "style-class-contain", "modal-class"]))
}
}

})